import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  formsFilterPlaceholder: {
    id: 'jira-common.ListProjectForms.FilterForms',
    defaultMessage: 'Filter forms',
    description: 'Placeholder for a text field where a user can type to search for a form by name.'
  }
});